import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'flowbite-react';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AreYouSure from '../../AreYouSure';
import { EnvironmentContext } from '../context';

const SummaryCard = () => {
  const ctx = useContext(EnvironmentContext);
  const navigate = useNavigate();
  const { env } = ctx.state;
  const { deleteEnvironment } = ctx.actions;

  const stackState = env?.stack.stackState;

  const canDelete = stackState === 'NOT_CREATED' || stackState === 'INACTIVE' || stackState === 'DELETED';

  const [showConfirmation, setShowConfirmation] = useState(false);
  const delEnv = () => {
    setShowConfirmation(false);
    deleteEnvironment(env.id);
    navigate('/dev', { replace: true });
  };

  return (
    <>
      {env?.id && (
        <>
          <div className="max-w-[480px] mb-6 p-2 rounded-lg bg-white border border-gray-200 shadow-md">
            <div className="float-right">
              <Tooltip content="Delete Environment" style="light">
                <button
                  className={`${
                    canDelete ? '' : 'hidden'
                  } py-1 px-2 mr-2 mb-2 text-lg font-medium text-gray-900 focus:outline-none rounded-lg hover:text-red-500 focus:z-10 focus:ring-4 focus:ring-gray-200`}
                  onClick={() => setShowConfirmation(true)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </Tooltip>
            </div>
            <h5 className="text-2xl mb-2">
              <span className="font-bold">Site name:</span>
              <span className="text-gray-700"> {env.name}</span>
            </h5>
            <p className="mb-2 text-gray-700">
              <span>Public IP: </span>
              dev.bioplan.ai
            </p>
            {stackState === 'ACTIVE' && (
              <a
                href={`https://${env.stack.name}.dev.bioplan.ai`}
                target="_blank"
                rel="noopener noreferrer"
                className="no-underline hover:underline"
              >
                {`https://${env.stack.name}.dev.bioplan.ai`}
              </a>
            )}
          </div>
        </>
      )}
      <AreYouSure visible={showConfirmation} yes={delEnv} no={() => setShowConfirmation(false)} message="environment" />
    </>
  );
};

export default SummaryCard;
